/* Byrna homepage redesign (#1520) — mobile carousels + click-to-play video facade.
   Idempotent: guarded so a duplicate include or a theme-editor re-render won't
   double-initialise. No YouTube assets load until the facade is clicked. */
(function () {
  // GA4 (#1527) — every event carries feature_name + issue_number via ByrnaGA4.
  var GA_NAME = 'homepage_redesign';
  var GA_ISSUE = '1527';
  function gaClick(extras) {
    var g = window.ByrnaGA4;
    if (g && typeof g.featureClick === 'function') g.featureClick(GA_NAME, GA_ISSUE, extras);
  }
  function gaFeature(action, extras) {
    var g = window.ByrnaGA4;
    if (g && typeof g.feature === 'function') g.feature(action, GA_NAME, GA_ISSUE, extras);
  }

  function initVideo(root) {
    root.querySelectorAll('.byrna-hp__yt-facade').forEach(function (f) {
      if (f.dataset.hpInit) return;
      f.dataset.hpInit = '1';
      var play = function () {
        if (f.dataset.hpPlaying) return;
        f.dataset.hpPlaying = '1';
        var id = f.getAttribute('data-yt');
        gaFeature('video_play', { surface: 'works' });
        var title = f.getAttribute('data-yt-title') || 'Video';
        var ifr = document.createElement('iframe');
        ifr.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
        ifr.title = title;
        ifr.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        ifr.setAttribute('allowfullscreen', '');
        f.innerHTML = '';
        f.appendChild(ifr);
      };
      f.addEventListener('click', play);
      f.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); play(); }
      });
    });
  }

  function initSliders(root) {
    var GAP = 14;
    var svgFor = function (dir) {
      var pts = dir === 'prev' ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
      return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="' + pts + '"></polyline></svg>';
    };
    root.querySelectorAll('.byrna-hp__rows, .byrna-hp__stories, .byrna-hp__scenes, .byrna-hp__prods').forEach(function (slider) {
      if (slider.dataset.hpInit) return;
      slider.dataset.hpInit = '1';

      var wrap = document.createElement('div');
      wrap.className = 'byrna-hp__slider-wrap';
      slider.parentNode.insertBefore(wrap, slider);
      wrap.appendChild(slider);

      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'byrna-hp__slider-nav byrna-hp__prev';
      prev.setAttribute('aria-label', 'Previous');
      prev.innerHTML = svgFor('prev');
      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'byrna-hp__slider-nav byrna-hp__next';
      next.setAttribute('aria-label', 'Next');
      next.innerHTML = svgFor('next');
      wrap.appendChild(prev);
      wrap.appendChild(next);

      function step() {
        var card = slider.firstElementChild;
        return card ? card.getBoundingClientRect().width + GAP : slider.clientWidth * 0.86;
      }
      // GA4 (#1527): fire feature_carousel_interact once per carousel per page
      // view, mobile-only — the carousel is only active at ≤600px (matches the
      // scroll-snap breakpoint in byrna-homepage.css). Arrow click and first
      // swipe (scroll) both count as the single interaction.
      var mql = window.matchMedia('(max-width: 600px)');
      function interact() {
        if (slider.dataset.gaFired || !mql.matches) return;
        slider.dataset.gaFired = '1';
        gaFeature('carousel_interact', { surface: slider.getAttribute('data-ga-carousel') || '' });
      }

      prev.addEventListener('click', function () { interact(); slider.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { interact(); slider.scrollBy({ left: step(), behavior: 'smooth' }); });

      function update() {
        var max = slider.scrollWidth - slider.clientWidth;
        prev.classList.toggle('byrna-hp__hidden', slider.scrollLeft <= 2);
        next.classList.toggle('byrna-hp__hidden', slider.scrollLeft >= max - 2);
      }
      slider.addEventListener('scroll', update, { passive: true });
      slider.addEventListener('scroll', interact, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  // GA4 (#1527): delegated feature_click on the six quiz CTAs. Each anchor
  // carries data-ga-cta with its surface (hero / how / video_band / stories /
  // fit / product_grid); the value becomes the `surface` param.
  function initClicks(root) {
    if (root.dataset.hpGaClicks) return;
    root.dataset.hpGaClicks = '1';
    root.addEventListener('click', function (e) {
      var el = e.target && e.target.closest ? e.target.closest('[data-ga-cta]') : null;
      if (!el || !root.contains(el)) return;
      gaClick({ surface: el.getAttribute('data-ga-cta') });
    });
  }

  function init() {
    document.querySelectorAll('.byrna-hp').forEach(function (root) {
      initVideo(root);
      initSliders(root);
      initClicks(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run on Shopify theme-editor section load.
  document.addEventListener('shopify:section:load', init);
})();
